import { render, staticRenderFns } from "./MBFTransactions.vue?vue&type=template&id=fcbd7bba"
import script from "./MBFTransactions.vue?vue&type=script&lang=js"
export * from "./MBFTransactions.vue?vue&type=script&lang=js"
import style0 from "./MBFTransactions.vue?vue&type=style&index=0&id=fcbd7bba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports